'use client';

import { useLayoutEffect } from 'react';

import ErrorPage from '.';

const AUTO_RESET_KEY_NAME = '__is_auto_reset';

export default function ErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  const isAutoReset = localStorage.getItem(AUTO_RESET_KEY_NAME);

  useLayoutEffect(() => {
    if (!isAutoReset) {
      reset();
      console.log('reset the error automatically.');
      localStorage.setItem(AUTO_RESET_KEY_NAME, 'true');
    }
    console.log('caught an exception in error boundry', error);
  }, [error, isAutoReset, reset]);

  return !isAutoReset ? null : (
    <ErrorPage
      digest={error.name}
      onReset={() => {
        localStorage.removeItem(AUTO_RESET_KEY_NAME);
        window.location.reload();
      }}
    />
  );
}
